// ---------------------------------------------------------------
// ErrorBoundary.js — Red de seguridad si algo revienta en pantalla.
//
// Sin esto, un error dentro de cualquier componente hace que React
// desmonte el árbol entero y el empleado se queda mirando una página
// EN BLANCO, sin saber si es su móvil, el wifi o la web. A las nueve
// de la mañana en el mostrador eso es lo peor que puede pasar.
//
// Va puesto alrededor de CADA sección por separado, no una sola vez
// arriba del todo: así un fallo en Tareas deja el resto de la web en
// pie y se puede seguir fichando, que es lo que no puede faltar.
//
// Tiene que ser una clase: los hooks no pueden capturar errores de
// renderizado, `componentDidCatch` no tiene equivalente moderno.
// ---------------------------------------------------------------
import { Component } from "react";
import Icon from "./ui/Icon";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Queda en la consola para poder mirarlo luego: no hay servicio
    // de registro de errores y tampoco hace falta para una farmacia.
    console.error("Fallo en la sección:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Al cambiar de sección se limpia el error: si no, la pantalla de
    // fallo se quedaría pegada aunque navegues a otro sitio.
    if (this.state.error && prevProps.seccion !== this.props.seccion) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="card fallo-card">
        <div className="fallo-icono">
          <Icon name="warning" size={26} />
        </div>
        <h3 className="fallo-titulo">Esta parte no se ha podido cargar</h3>
        <p className="fallo-texto">
          Ha fallado algo al mostrar esta sección. El resto de la web sigue
          funcionando: puedes cambiar de apartado desde el menú y seguir
          fichando con normalidad.
        </p>
        <div className="fallo-acciones">
          <button
            className="btn-primary"
            onClick={() => this.setState({ error: null })}
          >
            Volver a intentarlo
          </button>
          <button
            className="btn-secondary"
            onClick={() => window.location.reload()}
          >
            Recargar la página
          </button>
        </div>
        <p className="fallo-detalle">
          Si vuelve a pasar, dile a Alejandro qué estabas haciendo y enséñale
          esto: <code>{String(this.state.error?.message || this.state.error)}</code>
        </p>
      </div>
    );
  }
}
